import { useState } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import type { SelectAction } from "@outpave/ds";

/** Lets a picker that opens on recent picks list every allocation instead, for a user who would rather scroll than search. */
export function useBrowseAllAllocations() {
  const { t } = useTranslation();
  const [browseAll, setBrowseAll] = useState(false);

  const browseAction = (query: string): SelectAction | undefined =>
    query || browseAll
      ? undefined
      : {
          label: (
            <Typography component="span" variant="body2" color="inherit">
              <Typography
                component="span"
                variant="body2"
                sx={{ color: "var(--color-text-secondary)" }}
              >
                {t("SearchToFindAllocationPrompt")}
              </Typography>{" "}
              {t("Show all")}
            </Typography>
          ),
          keepOpen: true,
          onClick: () => setBrowseAll(true),
        };

  return { browseAll, browseAction };
}
